/**
 * Feature Requests Route Definition
 * Route: /feature-requests
 */
import { createFileRoute } from '@tanstack/react-router';
import { cacheFirst } from '@/lib/queries/cache-first';
import { featureRequestListQuery } from '@/lib/queries/detail';
import { FeatureRequestListPending } from './-list-pending';
import { createDeferredCatalogueLoaderData } from '../-catalogue-loader-data';

export const Route = createFileRoute('/_authenticated/feature-requests/')({
  // Template-first pending while the list page chunk downloads (first visit):
  // real header + title chrome, only the cards skeleton.
  pendingComponent: FeatureRequestListPending,
  loader: async ({ context }) => {
    // The default landing state (all/votes). Per-user vote state → private.
    const listKey = ['feature-requests', 'all', 'votes'] as const;
    // Cache-first: a cached list streams instantly while the plane heals
    // staleness in the background, so re-entry after the 5-minute staleTime
    // never re-suspends the whole list behind skeletons; a cold cache keeps the
    // streamed loader fetch. Single source of truth: the entry cards
    // data-prefetch this exact query ahead of the tap (home's View All primes it
    // on viewport entry), so the factory lives in @/lib/queries/detail and both
    // the loader and the prefetcher consume it.
    const { cached, stream } = cacheFirst(context.queryClient, listKey, () =>
      context.queryClient.ensureInfiniteQueryData(featureRequestListQuery())
    );
    return createDeferredCatalogueLoaderData(
      cached !== undefined ? Promise.resolve(cached) : stream()
    );
  },
});
